/**
 * Free Gift Progress Bar
 * Config comes from window.FGB (set by sections/free-gift-bar.liquid).
 * - Shows a progress bar under the cart drawer heading.
 * - Adds free gifts when a milestone is reached, removes them when the cart drops below it.
 */
(function () {
  if (window.__fgbReady || !window.fetch) return;
  window.__fgbReady = true;

  var oldFetch = window.fetch;
  var nativeFetch = oldFetch.bind(window);
  var CART_URL = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var timer = 0, running = false, again = false, queued = false, bar = null;
  var last = { sub: 0, count: 0 };

  var GIFT = '<svg class="fgb__ic fgb__ic-gift" viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13M5 12v7.5A1.5 1.5 0 0 0 6.5 21h11a1.5 1.5 0 0 0 1.5-1.5V12"/><path d="M12 8C10.5 4.5 7 4 7 6.3 7 8 9 8 12 8Zm0 0c1.5-3.5 5-4 5-1.7C17 8 15 8 12 8Z"/></svg>';
  var CHECK = '<svg class="fgb__ic fgb__ic-check" viewBox="0 0 24 24" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';

  function cfg() { return window.FGB; }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  function money(cents) {
    var f = String(cfg().fmt || '{{amount}}').replace(/<[^>]*>/g, '');
    var ta = document.createElement('textarea');
    ta.innerHTML = f;
    f = ta.value;
    var m = f.match(/\{\{\s*(\w+)\s*\}\}/), k = m ? m[1] : 'amount';
    var comma = /comma/.test(k);
    var th = comma ? '.' : /space/.test(k) ? ' ' : /apostrophe/.test(k) ? "'" : ',';
    var p = (cents / 100).toFixed(/no_decimals/.test(k) ? 0 : 2).split('.');
    var v = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th) + (p[1] && p[1] !== '00' ? (comma ? ',' : '.') + p[1] : '');
    return f.replace(/\{\{\s*\w+\s*\}\}/, v);
  }

  function setText(p, tpl, amount) {
    p.textContent = '';
    String(tpl || '').split('{amount}').forEach(function (s, i) {
      if (i) { var b = document.createElement('strong'); b.textContent = amount; p.appendChild(b); }
      p.appendChild(document.createTextNode(s));
    });
  }

  /* ---------- Bar (built once, moved back in place if the theme redraws the drawer) ---------- */
  function node(i, g) {
    return '<div class="fgb__node" data-n="' + i + '" style="left:' + (i === 1 ? '50' : '100') + '%" title="' + esc(g.title) + '">' +
      '<span class="fgb__icon">' + GIFT + CHECK + '</span>' +
      '<span class="fgb__amt">' + esc(g.amt) + '</span>' +
      '<span class="fgb__lbl">' + esc(cfg().label) + '</span></div>';
  }

  function build() {
    var c = cfg(), el = document.createElement('div');
    el.className = 'fgb';
    el.hidden = true;
    el.innerHTML = '<p class="fgb__msg" aria-live="polite"></p><div class="fgb__rail">' +
      '<div class="fgb__track" role="progressbar" aria-label="Free gift progress" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0"><span class="fgb__fill"></span></div>' +
      node(1, c.gifts[0]) + node(2, c.gifts[1]) + '</div>';
    return el;
  }

  function render() {
    var c = cfg();
    if (!c || !bar) return;
    var sub = last.sub, t1 = c.t1, t2 = c.t2;
    var pct = sub <= 0 ? 0 : sub < t1 ? sub / t1 * 50 : sub < t2 ? 50 + (sub - t1) / (t2 - t1) * 50 : 100;
    var stage = sub >= t2 ? 2 : sub >= t1 ? 1 : 0;
    var rem = stage === 2 ? 0 : Math.ceil(((stage === 0 ? t1 : t2) - sub) / 100) * 100;
    bar.hidden = last.count < 1;
    bar.setAttribute('data-stage', stage);
    bar.querySelector('.fgb__fill').style.setProperty('--p', pct / 100);
    bar.querySelector('[role=progressbar]').setAttribute('aria-valuenow', Math.round(pct));
    [t1, t2].forEach(function (t, i) {
      var n = bar.querySelector('[data-n="' + (i + 1) + '"]'), on = sub >= t;
      if (on && !n.classList.contains('is-unlocked') && bar.__ready) {
        n.classList.add('is-pop');
        setTimeout(function () { n.classList.remove('is-pop'); }, 600);
      }
      n.classList.toggle('is-unlocked', on);
    });
    var key = stage + ':' + rem + ':' + c.msg[stage];
    if (bar.__key !== key) {
      bar.__key = key;
      setText(bar.querySelector('.fgb__msg'), c.msg[stage], stage === 2 ? '' : money(rem));
    }
    bar.__ready = true;
  }

  /* Put the bar right under the cart heading (and the offer strip, if any). Cart must not be empty. */
  function ensure() {
    var c = cfg();
    var drawer = document.querySelector('cart-drawer-component');
    var header = drawer && drawer.querySelector('#cart-drawer-header');
    var anchor = header && drawer.querySelector('.cart-drawer__content');
    if (!c || !anchor) {
      if (bar && bar.parentNode) bar.remove();
      return;
    }
    if (!bar) {
      bar = build();
      render();
    }
    if (bar.nextElementSibling !== anchor) anchor.parentNode.insertBefore(bar, anchor);
  }

  function queueEnsure() {
    if (queued) return;
    queued = true;
    Promise.resolve().then(function () { queued = false; ensure(); });
  }

  /* ---------- Cart sync ---------- */
  function schedule() { clearTimeout(timer); timer = setTimeout(sync, 120); }

  function isGift(it, ids) {
    return ids.indexOf(it.variant_id) > -1 || !!(it.properties && it.properties._free_gift);
  }

  function stats(cart, c) {
    var ids = c.gifts.map(function (g) { return g.id; }), sub = 0;
    cart.items.forEach(function (it) { if (!isGift(it, ids)) sub += it.final_line_price; });
    return { sub: sub, ids: ids };
  }

  function getCart() {
    return nativeFetch(cfg().root + 'cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function post(path, body) {
    return nativeFetch(cfg().root + 'cart/' + path + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.ok; }, function () { return false; });
  }

  /* Add earned gifts, remove gifts that are not earned (or extra). Returns true if the cart changed. */
  async function reconcile(cart, c, s) {
    var want = {}, seen = {}, changed = false, i, id;
    c.gifts.forEach(function (g) { if (g.ok && s.sub >= g.min) want[g.id] = 1; });
    for (i = 0; i < cart.items.length; i++) {
      var it = cart.items[i];
      if (!isGift(it, s.ids)) continue;
      var dup = seen[it.variant_id];
      seen[it.variant_id] = 1;
      var q = want[it.variant_id] && !dup ? 1 : 0;
      if (it.quantity !== q && await post('change', { id: it.key, quantity: q })) changed = true;
    }
    for (id in want) {
      if (!seen[id] && await post('add', { items: [{ id: +id, quantity: 1, properties: { _free_gift: 'true' } }] })) changed = true;
    }
    return changed;
  }

  /* Tell the theme the cart changed, so it redraws the drawer lines and the cart count. */
  function refresh(cart) {
    var e = new Event('cart:update', { bubbles: true });
    e.detail = { resource: cart, sourceId: 'free-gift-bar', data: { source: 'free-gift-bar', itemCount: cart.item_count } };
    document.dispatchEvent(e);
  }

  async function sync() {
    if (running) { again = true; return; }
    var c = cfg();
    if (!c) return;
    running = true;
    try {
      var cart = await getCart(), s = stats(cart, c);
      last = { sub: s.sub, count: cart.item_count };
      render();
      if (await reconcile(cart, c, s)) {
        cart = await getCart();
        last = { sub: stats(cart, c).sub, count: cart.item_count };
        render();
        refresh(cart);
      }
    } catch (e) {}
    running = false;
    if (again) { again = false; schedule(); }
  }

  /* Watch cart changes made by the theme (fetch + XHR). Our own calls use nativeFetch, so there is no loop. */
  window.fetch = function (input) {
    var p = oldFetch.apply(this, arguments);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (CART_URL.test(url)) p.then(schedule, function () {});
    } catch (e) {}
    return p;
  };
  var xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    try { if (CART_URL.test(String(url))) this.addEventListener('loadend', schedule); } catch (e) {}
    return xhrOpen.apply(this, arguments);
  };

  /* ---------- Start ---------- */
  function start() {
    var c = cfg();
    if (c) last = { sub: c.sub, count: c.count };
    ensure();
    var root = document.getElementById('header-group') || document.body;
    new MutationObserver(queueEnsure).observe(root, { childList: true, subtree: true });
    if (c && c.count > 0) schedule();
  }

  /* Called again by the config script when settings change in the theme editor */
  window.__fgbRefresh = function () {
    var c = cfg();
    if (bar) { bar.remove(); bar = null; }
    if (c) last = { sub: c.sub, count: c.count };
    ensure();
    if (c && c.count > 0) schedule();
  };

  window.addEventListener('pageshow', function (e) { if (e.persisted) schedule(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();